import { useCallback } from "react";

import { SectionType } from "components/server-types";
import { ORDER_BY_TITLE } from "mds/hooks/use-ordered";
import { useAppSelector } from "store/index";
import { selectTermMap } from "store/selectors";

export const useIsArchived = () => {
  const terms = useAppSelector(selectTermMap);

  const isArchived = useCallback(
    (course: SectionType) => {
      const term = course.term_id ? terms[course.term_id] : undefined;
      return Boolean(course.archived_at || term?.archived_at);
    },
    [terms],
  );

  const isActive = useCallback((course: SectionType) => !isArchived(course), [isArchived]);

  const sortByActiveTitles = useCallback(
    (a: SectionType, b: SectionType) => {
      const aArchived = isArchived(a);
      const bArchived = isArchived(b);

      if (aArchived && !bArchived) return 1;
      if (!aArchived && bArchived) return -1;

      // eslint-disable-next-line babel/new-cap
      return ORDER_BY_TITLE(a, b);
    },
    [isArchived],
  );

  return { isArchived, isActive, sortByActiveTitles };
};
